export default __webpack_public_path__ + "static/media/globe.5ac31fa0.svg";